/**
 * Assistant Software OTA control model.
 * Installed must be device-confirmed; Available is staging approved Assistant artifact.
 * Canonical install path: Player update_assistant_app on the KK channel.
 *
 * Shared inventory compare/display lives in softwareInventoryModel.
 */

import {
  ASSISTANT_PACKAGE_NAME,
  displaySoftwareVersion,
  isSoftwareUpdateAvailable,
  isSoftwareUpToDate,
} from "./softwareInventoryModel";

export { ASSISTANT_PACKAGE_NAME };

export const ASSISTANT_UPDATE_COMMAND = "update_assistant_app" as const;

export type AssistantPackageIdentity = {
  versionCode: number;
  versionName: string;
  displayVersion?: string | null;
};

export const displayAssistantSoftwareVersion = displaySoftwareVersion;

export function isAssistantSoftwareUpdateAvailable(args: {
  installedVersionCode?: number | null;
  availableVersionCode?: number | null;
}): boolean {
  return isSoftwareUpdateAvailable(args);
}

export function isAssistantSoftwareUpToDate(args: {
  installedVersionCode?: number | null;
  availableVersionCode?: number | null;
}): boolean {
  return isSoftwareUpToDate(args);
}

/** Exact Fleet command body — Player installs Assistant (never Assistant self-OTA). */
export function buildAssistantPackageUpdateBody(): {
  command: typeof ASSISTANT_UPDATE_COMMAND;
} {
  return { command: ASSISTANT_UPDATE_COMMAND };
}
